import { render, staticRenderFns } from "./ProductionViewConfiguratorStep3.vue?vue&type=template&id=48ba5d9f"
import script from "./ProductionViewConfiguratorStep3.vue?vue&type=script&lang=js"
export * from "./ProductionViewConfiguratorStep3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports